import type { FilterRuleModel } from '@/shared/components/filter/types'

import { create } from 'zustand'
import { useShallow } from 'zustand/shallow'

/**
 * Zustand store
 */
type DashboardState = {
	filters: Record<string, FilterRuleModel[]>
	setFilters(key: string, filters: FilterRuleModel[]): void
	setStoredKeys(key: string, storedKeys: string[]): void
	storedKeys: Record<string, string[]>
}

export const useDashboardStore = create<DashboardState>(
	/* persist( */
	(set) => ({
		filters: {},
		storedKeys: {},
		setStoredKeys: (key: string, storedKeys: string[]) =>
			set((state) => ({
				storedKeys: {
					...state.storedKeys,
					[key]: storedKeys,
				},
			})),
		setFilters: (key: string, filters: FilterRuleModel[]) =>
			set((state) => ({
				filters: {
					...state.filters,
					[key]: filters,
				},
			})),
	})
)
const arr: FilterRuleModel[] = []
export const useSelectDashboardFilters = (key: string) =>
	useShallow((state: DashboardState) => ({
		setFilters: state.setFilters,
		filters: state.filters[key] || arr,
	}))
export const useSelectDashboardFiltersKeys = (key: string) =>
	useShallow((state: DashboardState) => ({
		setStoredKeys: state.setStoredKeys,
		storedKeys: state.storedKeys[key] || arr,
	}))
